import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { UserType } from 'app/core/user/user.types';
import { map, take } from 'rxjs';

/** The only page of the simulation team's shared accounts. */
export const SIMULATION_LOOKUP_URL = '/cauta-copil';

/**
 * Keeps the simulation team (`simulation_staff`) on „Caută copil”: it is where they land
 * after signing in (instead of Statistici) and where any other admin URL sends them back
 * — every other page calls endpoints that refuse them. Listed AFTER AuthGuard: the router
 * settles guards in order, so the user is known by the time this one is read.
 */
export const SimulationStaffGuard: CanActivateChildFn = (_route, state) => {
    const router = inject(Router);

    return inject(UserService).user$.pipe(
        take(1),
        map((user) =>
            user?.type !== UserType.simulation_staff ||
            state.url === SIMULATION_LOOKUP_URL ||
            state.url.startsWith(`${SIMULATION_LOOKUP_URL}?`) ||
            state.url.startsWith(`${SIMULATION_LOOKUP_URL}/`)
                ? true
                : router.parseUrl(SIMULATION_LOOKUP_URL)
        )
    );
};
